import { makeAutoObservable } from 'mobx';
import { Exception } from './types';

function isSameException(a: Error, b: Error): boolean {
  if (a.message !== b.message) return false;

  const aStackLine = a.stack?.split('\n')[2]?.trim();
  const bStackLine = b.stack?.split('\n')[2]?.trim();

  return aStackLine === bStackLine;
}

class Store {
  private _exceptions: Exception[] = [];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  get exceptions() {
    return this._exceptions;
  }

  addException(exception: Exception) {
    // Check if the exception is already in the list
    if (
      this._exceptions.some((ex) => isSameException(ex.error, exception.error))
    ) {
      return;
    }
    // Add the exception to the list
    this._exceptions.push(exception);
  }

  removeLastException() {
    console.log('Removing last exception', this._exceptions);
    if (this._exceptions.length > 0) {
      this._exceptions.pop();
    }
  }

  clearExceptions() {
    this._exceptions = [];
  }
}

export const ExceptionStore = new Store();
